var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12002 14.7099L12 10.8299L15.88 14.7099C16.27 15.0999 16.9 15.0999 17.29 14.7099C17.68 14.3199 17.68 13.6899 17.29 13.2999L12.7 8.70994C12.31 8.31994 11.68 8.31994 11.29 8.70994L6.70002 13.2999C6.31002 13.6899 6.31002 14.3199 6.70002 14.7099C7.09002 15.0899 7.73002 15.0999 8.12002 14.7099Z",
    fill: "#353434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpSmall);
export default __webpack_public_path__ + "static/media/arrow-up-small.705f16af885c9c4c6de6cfe1788bddd5.svg";
export { ForwardRef as ReactComponent };